import {
  Checkbox,
  Collapse,
  FormControlLabel,
  IconButton,
  InputAdornment,
  Paper,
  Stack,
  TextField,
  Tooltip,
} from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import SearchIcon from '@mui/icons-material/Search';
import { MIN_SEARCH_LENGTH } from '../../../utils/searchConstants';
import { ClearFiltersButton } from '../../common/components';

interface StockFiltersProps {
  show: boolean;
  filterName: string;
  onFilterNameChange: (value: string) => void;
  showOnlyActive: boolean;
  onShowOnlyActiveChange: (value: boolean) => void;
  onClearFilters: () => void;
}

export const StockFilters = ({
  show,
  filterName,
  onFilterNameChange,
  showOnlyActive,
  onShowOnlyActiveChange,
  onClearFilters,
}: StockFiltersProps) => {
  return (
    <Collapse in={show}>
      <Paper sx={{ p: 2, mb: 2, backgroundColor: 'background.default' }} variant="outlined">
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center">
          <TextField
            label="Пошук за назвою"
            variant="outlined"
            size="small"
            fullWidth
            value={filterName}
            onChange={(e) => onFilterNameChange(e.target.value)}
            helperText={filterName.length > 0 && filterName.length < MIN_SEARCH_LENGTH ? `Введіть щонайменше ${MIN_SEARCH_LENGTH} символів для пошуку` : ' '}
            sx={{ flexGrow: 1 }}
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon color="action" />
                  </InputAdornment>
                ),
                endAdornment: filterName && (
                  <InputAdornment position="end">
                    <Tooltip title="Очистити">
                      <IconButton size="small" onClick={() => onFilterNameChange('')}>
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </InputAdornment>
                ),
              },
            }}
          />
        </Stack>
        <FormControlLabel
          control={(
            <Checkbox
              checked={showOnlyActive}
              onChange={(e) => onShowOnlyActiveChange(e.target.checked)}
            />
          )}
          label="Показувати лише активні"
          sx={{ mt: 1, ml: 0 }}
        />
        {filterName && (
          <ClearFiltersButton onClick={onClearFilters} />
        )}
      </Paper>
    </Collapse>
  );
};
